import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {BehaviorSubject, map, Observable, tap} from "rxjs";
import {LoaderService} from "./loader.service";
import {
  ActionResult,
  ActionResultList,
  ADMINISTRATOR_ROLE_ID,
  FindUsersDetailsRequest,
  RoleEdit,
  UserDetail
} from "@model";
import {EnvironmentService} from "./environment.service";

@Injectable({ providedIn:'root' })
export class AdministratorsService {
  private static _currentUserDetails: BehaviorSubject<UserDetail | undefined> = new BehaviorSubject<UserDetail | undefined>(undefined);

  get currentUserDetails(): BehaviorSubject<UserDetail | undefined> {
    return AdministratorsService._currentUserDetails;
  }

  constructor(private http: HttpClient, private loaderService: LoaderService, private environmentService:EnvironmentService) {
  }

  findAdministrators(showLoader: boolean = false): Observable<UserDetail[]> {
    if (showLoader) {
      this.loaderService.startLoading();
    }
    return this.http.get<ActionResultList<UserDetail[], number>>(this.environmentService.getApiUrl() + "/api/administrators/fetchadmins").pipe(tap(() => {
      if (showLoader) {
        this.loaderService.dismissLoading();
      }
    }), map((value: ActionResultList<UserDetail[], number>) => {
      if (value && value.result && value.result.length != 0) {
        return value.result;
      } else {
        return [];
      }
    }));
  }

  addAdministrator(email: string): Observable<boolean> {
    let roleEdit: RoleEdit = new RoleEdit(email, undefined, ADMINISTRATOR_ROLE_ID, undefined);
    this.loaderService.startLoading();
    return this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + `/api/administrators/editadminrole/email`, roleEdit).pipe(tap(() => {
        this.loaderService.dismissLoading()
      }),
      map((value: ActionResult<boolean>) => {
        return value.result ?? false;
      }));
  }

  deleteAdministrator(userId: number): Observable<boolean> {
    this.loaderService.startLoading();
    return this.http.post<ActionResult<boolean>>(this.environmentService.getApiUrl() + "/api/administrators/removeadminrole", userId).pipe(tap(() => {
        this.loaderService.dismissLoading()
      }),
      map((value: ActionResult<boolean>) => {
        return value.result ?? false;
      }));
  }


  findUsers(userFilter: FindUsersDetailsRequest, hideLoading?: boolean, onStartFetch?: () => void, onEndFetch?: () => void): Observable<UserDetail[]> {
    if (onStartFetch) {
      onStartFetch();
    }
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResultList<UserDetail[], number>>(this.environmentService.getApiUrl() + "/api/administrators/getusersbyrole", userFilter).pipe(tap(() => {
      if (onEndFetch) {
        onEndFetch();
      }
      if (!hideLoading) {
        this.loaderService.dismissLoading();
      }
    }), map((value: ActionResultList<UserDetail[], number>) => {
      if (value && value.result && value.result.length != 0) {
        return value.result;
      } else {
        return [];
      }
    }));
  }

  fetchUser(userId: number, hideLoading?: boolean): Observable<UserDetail | null> {
    if (!hideLoading) {
      this.loaderService.startLoading();
    }
    return this.http.post<ActionResult<UserDetail>>(this.environmentService.getApiUrl() + "/api/administrators/getuserdetailbyid", userId).pipe(tap(() => {
      if (!hideLoading) {
        this.loaderService.dismissLoading();
      }
    }), map((value: ActionResult<UserDetail>) => {
      if (value && value.result) {
        return value.result;
      } else {
        return null;
      }
    }));
  }
}
